import { render, staticRenderFns } from "./DnOrcid.vue?vue&type=template&id=73b2257e&scoped=true&"
import script from "./DnOrcid.vue?vue&type=script&lang=js&"
export * from "./DnOrcid.vue?vue&type=script&lang=js&"
import style0 from "./DnOrcid.vue?vue&type=style&index=0&id=73b2257e&lang=scss&scoped=true&"
import style1 from "./DnOrcid.vue?vue&type=style&index=1&id=73b2257e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b2257e",
  null
  
)

export default component.exports